:host {
  display: block;
}

.trss-alert {
  padding: 1em 0;
  margin: 0;
  font-size: 1rem;
  text-align: left;
  border-bottom: 2px solid;

  p {
    margin: .75em 0;
  }

  a {
    font-weight: 600;
    text-decoration: underline;
    color: inherit;
  }

  .row {
    margin: 0 auto;
  }

  .header {
    margin: 0 0 .25em 0;
    font-size: 1.4rem;
  }

}

.trss-alert--notice {
  background-color: #cce5ff;
  border-color: #b8daff;
  color: #004085;
}

.trss-alert--clear {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.trss-alert--warning {
  background-color: #fff3cd;
  border-color: #ffeeba;
  color: #856404;
}

.trss-alert--emergency {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}
